export default "__VITE_ASSET__DnVcczaA__"